/**
 * 86bc8j9ur: the "verify your identity" link under the landlord's name in the
 * header, which replaced the yellow banner at the top of every page. New
 * landlords are prompted by step 3 of the onboarding checklist; this link
 * covers landlords whose verification expired after a year, and those who
 * never verified.
 *
 * Stays hidden while the blue PmcRegisterBanner is showing. HandleInertiaRequests
 * derives is_experian_verified as `personal || (agent && has_company_experian_token)`,
 * so completing the PMC registration sets the company token and clears this
 * prompt on its own: the two are one action, not two.
 *
 * @param {{role?: string, is_admin?: boolean, is_experian_verified?: boolean, is_experian_verification_expired?: boolean, needs_pmc_registration?: boolean}|null|undefined} user
 * @returns {string|null} The link text, or null when no link should show.
 */
export function experianVerificationPrompt(user) {
    if (! user || user.role !== 'agent' || user.is_admin) {
        return null;
    }

    if (user.is_experian_verified || user.needs_pmc_registration) {
        return null;
    }

    return user.is_experian_verification_expired
        ? 'Profile Verification Expired'
        : 'Verify your identity';
}
